import VueRouter from "vue-router";

import index from '../pages/index'
import login from '../pages/login'
import user from '../pages/user'
import xxcx from '../pages/xxcx'
import mbgg from '../pages/mbgg'
import kehu from '../pages/kehu'
import bdcx from '../pages/bdcx'
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
	if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
	return originalPush.call(this, location).catch(err => err)
}
const router = new VueRouter({
	routes: [{
			path: '/',
			name: 'login',
			component: login,
		},

		{
			path: '/index',
			meta: {
				requireAuth: true, // 判断是否须要登陆
			},
			name: 'index',
			component: index,
			redirect: '/xxcx',
			children: [

				{
					path: '/xxcx',
					name: 'xxcx',
					component: xxcx,
				},
				{
					path: '/mbgg',
					name: 'mbgg',
					component: mbgg,
				},
				{
					path: '/kehu',
					name: 'kehu',
					component: kehu,
				},
				{
					path: '/bdcx',
					name: 'bdcx',
					component: bdcx,
				},
			]
		},

	]
})

router.beforeEach((to, from, next) => {
	console.log(to, from, next);
	//requireAuth对应上面每个跳转的 meta:{requireAuth:true},

	//配置上说明访问该路径时需要检测是否登录状态
	//console.log(to)


	//sessionStorage可直接使用，无需引入

	//在登录页，点击登录按钮后设置sessionStorage.setItem("key","value")

	//通过sessionStorage.getItem("account")获取，如果有值则是登录状态,无值则为未登录，自动跳转到登录页
	
	
	if (to.matched[0].meta.requireAuth) {
		if (sessionStorage.getItem("token") === null) {
			next('/');
		} else {
			next()
		}
	} else {
		next()
	}
	// next()
});
export default router